export const OpenAPI = {
    BASE: 'https://10.1.2.231:8080/',
    VERSION: '1.0.3',
    WITH_CREDENTIALS: false,
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
};
//# sourceMappingURL=OpenAPI.js.map